export const HERO_MS = 7000;

export const HEADLINE = 'Software and AI, built to ship.';
// Alternatives from the design brief:
// 'We build the software your business runs on, and the AI that makes it smarter.'
// 'Custom software. Production AI. One engineering team.'

const HERO = [
  {
    label: 'Software and AI',
    eyebrow: 'Software & AI engineering',
    title: HEADLINE,
    sub: 'A senior engineering team building web platforms, mobile apps and production AI for growing companies, and keeping them running after launch.',
    cta: 'See our work',
    href: '#work',
    image: '/images/hero-1.jpg',
    alt: 'Software engineer at work',
  },
  {
    label: 'Production AI',
    eyebrow: 'AI and LLM solutions',
    title: 'AI that works on your data, in production.',
    sub: 'Agents, RAG search and document automation with evaluations, cost limits and monitoring. Built to pass real traffic, not just a demo.',
    cta: 'Explore services',
    href: '#services',
    image: '/images/hero-2.jpg',
    alt: 'AI product in use',
  },
  {
    label: 'Full product teams',
    eyebrow: 'Web · Mobile · SaaS · Cloud',
    title: 'One team, from first sprint to scale.',
    sub: 'Discovery, design, build and DevOps under one roof. Working software every two weeks, code and docs handed over in full.',
    cta: 'How we work',
    href: '#process',
    image: '/images/hero-3.jpg',
    alt: 'Operations software in the field',
  },
];
export default HERO;
